export interface PasswordRule {
  key: string;
  test: (password: string) => boolean;
}

// A strict superset of the backend's own rule (min 8 chars + a digit) so the
// checklist never blocks a submission the backend would actually accept.
export const PASSWORD_RULES: PasswordRule[] = [
  { key: "minLength", test: (password) => password.length >= 8 },
  { key: "uppercase", test: (password) => /[A-Z]/.test(password) },
  { key: "digit", test: (password) => /\d/.test(password) },
];

export const passwordMeetsAllRules = (password: string): boolean =>
  PASSWORD_RULES.every((rule) => rule.test(password));
